import type { LinkProps } from 'next/link';
import type { ComponentProps } from 'react';
import Link from 'next/link';
import { type Placement } from '@floating-ui/react-dom';

import type { ButtonProps, ButtonPropsSizeType } from '@poseidon/components/Button';
import type { TooltipLabel } from '@poseidon/components/Tooltip';
import { ButtonIcon, ButtonText } from '@poseidon/components/Button';
import { buttonCommonClassName } from '@poseidon/components/common';
import { Tooltip } from '@poseidon/components/Tooltip';

type ButtonLinkProps = Omit<ComponentProps<'a'>, 'href' | 'type'> &
  LinkProps & {
    size?: ButtonPropsSizeType;
    tooltip?: TooltipLabel;
    tooltipPlacement?: Placement;
    type?: ButtonProps['type'];
    disabled?: ButtonProps['disabled'];
    icon?: React.ReactNode;
    rIcon?: React.ReactNode;
    text?: boolean;
  };

export default function ButtonLink({
  children,
  className,
  href,
  size,
  tooltip,
  type,
  tooltipPlacement,
  icon,
  disabled,
  rIcon,
  text,
  ...props
}: ButtonLinkProps) {
  return (
    <Tooltip
      background={type === 'reset' ? 'rgb(215, 39, 65)' : undefined}
      label={tooltip}
      placement={tooltipPlacement}
      autoPlace={tooltipPlacement != null ? false : true}>
      <Link
        href={href}
        className={buttonCommonClassName({ size, disabled, type, text, className, clickable: true })}
        {...props}>
        {icon && <ButtonIcon size={size}>{icon}</ButtonIcon>}
        {children && <ButtonText size={size}>{children}</ButtonText>}
        {rIcon && <ButtonIcon size={size}>{rIcon}</ButtonIcon>}
      </Link>
    </Tooltip>
  );
}
